export const maxCampaignCount = 10; // maximum number of campaigns for a lift experiment
export const maxExperimentNameLength = 255; // maximum length of an experiment name
export const maxFetchedAdGroupsCount = 1000; // maximum number of AD Groups
export const maxFetchedAudienceCriterionCount = 1000; // maximum number of Audience Criterion
export const maxFetchedGoalsCount = 200; // maximum number of conversion goals to fetch
export const maxFetchedKeywordsCount = 200; // maximum number of keywords to fetch
export const maxFetchedTagsCount = 200; // maximum number of UET tags to fetch
export const maxKeywordCount = 20; // maximum number of keywords for a lift experiment
export const maxKeywordLength = 100; // maximum length of a keyword
export const maxSearchCid = 999999999; // maximum value for search CID
export const maxTagCount = 5; // maximum number of UET tags for a lift experiment
export const minSearchCid = 1; // minimum value for search CID
